<template>
  <div class="item-upload py-1 mb-1">
    <div class="col-12 p-0 m-0 d-flex justify-content-between">
      <span class="col-10">
        <small>{{ file.name }}</small>
      </span>
      <span class="col-2">
        <button class="btn btn-sm btn-danger" @click="finishUpload"><i class="fa fa-trash"></i></button>
      </span>
    </div>

    <div class="col-12">
      <div class="progress">
        <div
          class="progress-bar"
          :class="{ 'bg-danger': error }"
          role="progressbar"
          :style="`width:${ progress }%;`"
          :aria-valuenow="progress"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          {{ progress }}%
        </div>
      </div>
    </div>
    <div class="col-12" v-if="error">
      <p class="text-center"><small>Algo deu errado! Tentar novamente?</small>
        <button class="btn btn-sm btn-primary" @click="uploadFile"><i class="fas fa-redo-alt"></i></button>
      </p>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import { mapGetters } from 'vuex'
import tus from 'tus-js-client'

export default {
  props: {
    file: {
      required: true
    }
  },
  data () {
    return {
      upload: undefined,
      video_data: undefined,
      progress: 0,
      error: false,
      errorCount: 0,
      currentOffset: 0,
      tokens: [
        'bac2d0553e83a759d82a4bbc58837ca0',
        '42098387fe117991c85b63d81577d9c0',
        'f56500546147ff0d586e9c5530cf8595',
        'f28507730020d930f27d46f6ec766df2',
        '5d0d63e69c6dd728a7bacf6b53619bf1',
        'aa2939b60237307d425ed6b08740ba97',
        'a78b7e14d90828a31c36b847c15f4103',
        '642eac946d5b22e8f349e4c691a3d451'
      ]
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "getCurrentUser"
    }),
    selectedToken: function () {
      let min = Math.ceil(0);
      let max = Math.floor(7);
      let index = Math.floor(Math.random() * (max - min)) + min;
      return this.tokens[index]
    }
  },
  methods: {
    reloadLibrary: function () {
      this.$emit('finished', this.file);
    },

    finishUpload: async function () {
      // await new Promise(r => setTimeout(r, 1000 * (Math.random() * (3 - 1) + 1)));
      this.$emit('finished', this.file);
      this.$el.parentNode.removeChild(this.$el);
      if (this.upload) this.upload.abort()
    },

    sendFileVimeo: function (uri) {
      tus.canStoreURLs = true
      this.upload = new tus.Upload(this.file, {
        uploadUrl: uri,
        chunkSize: 200000000,
        retryDelays: [0, 3000, 5000, 10000, 20000, 30000],
        resume: true,
        metadata: {
            filename: this.file.name,
            filetype: this.file.type
        },
        onError: (error) => {
          this.error = true
          console.log("Failed: " + error)
        },
        onProgress: (bytesUploaded, bytesTotal) => {
          this.progress = ((bytesUploaded * 100) / bytesTotal).toFixed(0)
        },
        onSuccess: () => {
          console.log("Finished %s", this.upload.file.name)
          this.recordAtLibrary({
            name: this.video_data.name,
            uri: this.video_data.uri
          })
          this.finishUpload()
        }
      })
      this.upload.start()
    },

    uploadFileVimeo: function () {
      Axios.post(
        'https://api.vimeo.com/me/videos',
        {
          name: this.file.name,
          upload: {
            approach: "tus",
            size: this.file.size,
          }
        },
        {
          headers: {
            "Authorization": `bearer ${ this.selectedToken }`,
            "Content-Type": "application/json",
            "Accept": "application/vnd.vimeo.*+json;version=3.4"
          }
        }
      )
        .then(res => {
          this.video_data = res.data
          this.sendFileVimeo(res.data.upload.upload_link)
        })
        .catch( err => {
          console.error(err)
          this.error = true
        })
    },

    recordAtLibrary: function ( data ) {
      Axios.post("/teacher/library", {
          user: this.currentUser.id,
          name: data.name,
          url: data.uri,
          type: this.file.type,
        },
        {
          NotShowLoading: true
        }
      )
        .catch(err => {
          this.error = true
          console.error(err)
        })
        .then( () => {
          this.finishUpload()
        })
    },

    uploadFileStorage: function () {
      let formData = new FormData()
      formData.append('file', this.file)

      Axios.post(`/teacher/library/update`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: progress => {
            this.progress = ((progress.loaded * 100) / progress.total).toFixed(0)
          }
        }
      )
        .then((res) => {
          this.recordAtLibrary({
            name: res.data.name,
            uri: res.data.url
          })
        })
        .catch((err) => {
          this.error = true
          console.error(err)
        })
    },

    checkStatusVimeo: function(uri) {
      let check = setInterval(
        Axios.head(
          uri,
          {
            transformRequest: [
              (data, headers) => {
                delete headers.common.Authorization
                return data
              }
            ],
            headers: {
              "Tus-Resumable": "1.0.0",
              "Accept": "application/vnd.vimeo.*+json;version=3.4"
            },
          }
        )
          .then( res => {
            console.log( res )
          })
          .catch( err => {
            this.error = true
            console.error( err )
          })
      , 1000)
    },

    uploadFile: function () {
      this.error = false
      let type = this.file.type.split('/')
      if ( type[0] === "video" ) {
        this.uploadFileVimeo()
      } else {
        this.uploadFileStorage()
      }
    }
  },
  created () {
    this.uploadFile()
  }
}
</script>
